import React from 'react'
import LimitedViewText from './LimitedViewText'

import bgHeader from 'images/carousel-2.jpg'
import pdfLogo from 'images/pdf-logo.png'

export default function Information1({ regenerated, limitedView }) {
  const commonText = {
    title: 'Media touch points',
    listLeftTitle: 'You should:',
    listRightTitle: "You shouldn't:"
  };
  const texts = regenerated ? {
    listLeftText1: 'Take note of any update in their interests. If you have developed content based on their interest, check the KPIs and make sure you track what worked and what didn’t.',
    listLeftText2: 'Invest more in what worked, and drop the content that is not getting you results.',
    listLeftText3: 'Your audience’s behavior changes and the channels you choose can vary as well, keep optimizing your content and your media investments.',
    listLeftText4: 'If you used search, once again try to change some of the keywords you are bidding on. Search is an ongoing process. Never static .',
    listLeftText5: 'Keep testing and scale up what works.',
    listRightText1: 'Keep doing the same things and expecting different results.',
    listRightText2: 'Change what works. Be it content or channels.',
    listRightText3: 'Stress about influencers and try to get them all on board with your brand at the same time\n.',
    listRightText4: 'Invest all your budget at once.',
    ...commonText
  } : {
    listLeftText1: 'Take note of their interests and build your social media content around the same topics.',
    listLeftText2: 'Develop native advertising and place them on sites and blogs that cover these topics.',
    listLeftText3: 'Take note of the content creators relevant to your category. In this document lussy.io has give you a list. Use it.',
    listLeftText4: 'Search is a powerful media. Take note of the search words they look for and their cost per click\n.',
    listLeftText5: 'Test with small budgets, see what works and then scale up your investments\n.',
    listRightText1: 'Stress about being on all channels all the time.',
    listRightText2: 'Brands have a tendency to go for promoted clicks and pop up ads, if your audience doesn’t like them, then don’t fall into that trap.',
    listRightText3: 'Stress about influencers and try to get them all on board with your brand.',
    listRightText4: 'Invest all your budget at once.',
    ...commonText
  };

  return (
    <section className="section md-pt4 sm-p0" data-anchor="information-1">
      <div className="slider-box slider-box--pdf-p0 bg-white box-shadow-box p4 x-lg-p3">
        <div>
          <div className="flex mb2 pt3 sm-p0">
            <div className="bg-violet-red mr2 rounded-6" style={{ height: 20, width: 20 }} />
            <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
            <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
            <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
          </div>

          <h2 className="persona-sub-title mb4 sm-mb3">{texts.title}</h2>

          <div className="flex flex-wrap mxn2">
            <div className="col-6 flex px2 sm-col-12 sm-mb3">
              <div className="border border-violet-red box-shadow-around bw-2 col-12 overflow-hidden rounded-16">
                <div className="border-top border-violet-red bw-10 p3">
                  {limitedView ?
                    <LimitedViewText />
                    : <>
                      <p className="flex flex-center h3 mb3">
                        <i className="fa fa-check-circle fs-36 mr2 text-violet-red" />
                        {texts.listLeftTitle}
                      </p>

                      <ul className="list-square pl-20 text-violet-red">
                        <li className="mb2"><span className="text-black">{texts.listLeftText1}</span></li>
                        <li className="mb2"><span className="text-black">{texts.listLeftText2}</span></li>
                        <li className="mb2"><span className="text-black">{texts.listLeftText3}</span></li>
                        <li className="mb2"><span className="text-black">{texts.listLeftText4}</span></li>
                        <li><span className="text-black">{texts.listLeftText5}</span></li>
                      </ul>
                    </>
                  }
                </div>
              </div>
            </div>

            <div className="col-6 flex px2 sm-col-12">
              <div className="border border-iron box-shadow-around bw-2 col-12 overflow-hidden rounded-16">
                <div className="p3">
                  {limitedView ?
                    <LimitedViewText />
                    : <>
                      <p className="flex flex-center h3 mb3">
                        <i className="fa fa-times-circle fs-36 mr2 text-iron" />
                        {texts.listRightTitle}
                      </p>

                      <ul className="list-square pl-20 text-iron">
                        <li className="mb2"><span className="text-black">{texts.listRightText1}</span></li>
                        <li className="mb2"><span className="text-black">{texts.listRightText2}</span></li>
                        <li className="mb2"><span className="text-black">{texts.listRightText3}</span></li>
                        <li className="mb2"><span className="text-black">{texts.listRightText4}</span></li>
                      </ul>
                    </>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
